var render, staticRenderFns
import script from "./HighlightSectionGhostLoader.vue?vue&type=script&lang=tsx"
export * from "./HighlightSectionGhostLoader.vue?vue&type=script&lang=tsx"
import style0 from "./HighlightSectionGhostLoader.vue?vue&type=style&index=0&id=5163a454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163a454",
  null
  
)

export default component.exports